import { render, staticRenderFns } from "./IconTrashRestore.vue?vue&type=template&id=4134eebf&"
var script = {}
import style0 from "./IconTrashRestore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4134eebf')) {
      api.createRecord('4134eebf', component.options)
    } else {
      api.reload('4134eebf', component.options)
    }
    module.hot.accept("./IconTrashRestore.vue?vue&type=template&id=4134eebf&", function () {
      api.rerender('4134eebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconTrashRestore.vue"
export default component.exports